import { call, put, takeLatest } from "redux-saga/effects";
import { GET_AdminList, POST_Admin, PUT_Admin, DELETE_Admin } from "../services/Auth";
import exception from "../utils/exception";
import { jwtDecode, jwtEncode } from "../utils/jwt";
import { getToken } from "../utils/token";

function* GET_AdminListEffect({ callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const res = yield call(GET_AdminList, token);
    const resData = yield call(jwtDecode, res.data);
    yield put({ type: "SAVE_AdminList", payload: resData.data });
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* POST_AdminEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const formData = new FormData();
    const data = yield call(jwtEncode, payload);
    formData.append("data", data);
    yield call(POST_Admin, token, formData);
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* PUT_AdminEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const formData = new FormData();
    const data = yield call(jwtEncode, payload);
    formData.append("data", data);
    yield call(PUT_Admin, token, formData);
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* DELETE_AdminEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const data = yield call(jwtEncode, payload);
    const query = { Data: data };
    yield call(DELETE_Admin, token, query);
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

export default function* Example() {
  yield takeLatest("GET_AdminList", GET_AdminListEffect);
  yield takeLatest("POST_Admin", POST_AdminEffect);
  yield takeLatest("PUT_Admin", PUT_AdminEffect);
  yield takeLatest("DELETE_Admin", DELETE_AdminEffect);
}
